import React, { Fragment } from 'react';
import { Grid, Header } from 'semantic-ui-react';
import styled from 'styled-components';
import { LoadingBar, TableForm, Pagination } from 'components/Commons';
import cm from 'helpers/commons';
import delete1px from './img/delete1px_w.png';

const MenuTableCell = ({ align, menus, menuKey, classes, ...other }) => {
  const menuCell = menus.map((menu, index) => {
    const item = menuKey !== 'name' ? cm.numberComma(menu[menuKey]) : menu[menuKey];
    // 같은 메뉴를 여러 줄로 예약하면 id가 중복된다. 정렬·상태가 없는 정적 텍스트라 index를 함께 쓴다
    // eslint-disable-next-line react/no-array-index-key
    return <p key={`${menu.id}_${index}`}>{item}</p>;
  });
  return <Fragment>{menuCell}</Fragment>;
};

const BookingTimeResult = ({ data, pageClick }) => {
  let header = [
    { data: '예약시간', textAlign: 'left' },
    { data: 'ID', textAlign: 'left' },
    { data: '이름', textAlign: 'left' },
    { data: '식사명', textAlign: 'center' },
    { data: '제휴점명', textAlign: 'center' },
    { data: '메뉴명', textAlign: 'center' },
    { data: '수량', textAlign: 'right' },
    { data: '금액', textAlign: 'right' },
    { data: '예약상태', textAlign: 'center' },
    { data: '결제상태', textAlign: 'center' }
  ];

  let main = cm.tableHeaderList(header, 3, false, 'default');
  const tabledata = {
    header: {
      main: main
    },
    body: {
      message: '예약 목록이 없습니다.',
      main: null
    }
  };
  let pagingTmpl = null;
  let pagination_page = 1,
    pagination_pagerow = 0,
    pagination_totalcount = 0;

  if (data && data.contents && data.contents.length > 0) {
    const { contents, paging } = data;

    if (paging) {
      pagination_page = paging.page;
      pagination_pagerow = paging.pageRow;
      pagination_totalcount = paging.total;
    }

    let newData = contents.map((content) => {
      const { bookingDate, bookingGroup, user, menus, store, amount, status } = content;
      let booking = null;
      let payment = null;
      let color = null;
      let decoration = null;
      let backgroundImage = null;
      let backgroundSize = null;

      switch (status.booking) {
        case 'BOOKED':
          booking = '예약 완료';
          break;

        case 'CANCELED':
          booking = '예약 취소';
          color = '#dcdcdc';
          backgroundImage = `url(${delete1px})`;
          backgroundSize = 'contain';
          break;

        default:
          booking = '';
      }

      switch (status.payment) {
        case 'NONE':
          payment = '결제 없음';
          break;
        case 'PAYED':
          payment = '결제 완료';
          break;

        case 'CANCEL':
          payment = '결제 취소';

          break;

        default:
          payment = '';
      }

      let obj = {
        row: [
          {
            data: cm.yyyyMMddhhmm(bookingDate),
            textAlign: 'left'
          },
          {
            data: user.signId,
            textAlign: 'left'
          },
          {
            data: user.name,
            textAlign: 'left'
          },
          {
            data: bookingGroup,
            textAlign: 'center'
          },
          {
            data: store.name,
            textAlign: 'center'
          },
          {
            data: <MenuTableCell menus={menus} menuKey="name" />,
            textAlign: 'center'
          },
          {
            data: <MenuTableCell menus={menus} menuKey="quantity" />,
            textAlign: 'right'
          },
          {
            data: <MenuTableCell menus={menus} menuKey="totalPrice" />,
            textAlign: 'right'
          },
          {
            data: booking,
            textAlign: 'center'
          },
          {
            data: payment,
            textAlign: 'center'
          }
        ]
      };

      obj = cm.defalutTableStaffDivisionSet(obj.row, 3, content.user.orgIdx, 'stat');

      obj.row.forEach((item) => {
        item.textDecoration = decoration ? decoration : null;
        item.fontColor = color ? color : null;
        item.backgroundImage = backgroundImage ? backgroundImage : null;
        item.backgroundSize = backgroundSize ? backgroundSize : null;
      });

      return obj;
    });

    tabledata.body.main = newData;

    pagingTmpl = (
      <GridRowPaginationStyled>
        <Pagination
          page={pagination_page}
          pageRow={pagination_pagerow}
          pageBlock={10}
          totalCount={pagination_totalcount}
          pageClick={pageClick}
        />
      </GridRowPaginationStyled>
    );
  }

  return (
    <GridStyled>
      <Header as="h3">예약시간 기준</Header>
      <GridRowStyled className="table-box">
        <TableForm selectable="true" tabledata={tabledata} />
      </GridRowStyled>

      {pagingTmpl}
    </GridStyled>
  );
};

const GridStyled = styled(Grid)`
  &&&& {
    margin-bottom: 5rem;
  }
`;

const GridRowStyled = styled(Grid.Row)`
  &&&& {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const GridRowPaginationStyled = styled(Grid.Row)`
  &&&& {
    .pagination {
      margin: 0 auto;
    }
  }
`;

export default BookingTimeResult;
